import 'core-js/stable'
import 'regenerator-runtime/runtime'
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { axios } from "axios"; 
import preventReClick from '../src/common/js/preventRepeatClick';
import { IS_WECHAT_ENV } from "./config";

// 仅在微信专用模式且当前非微信环境时，跳转微信 OAuth 授权
if (IS_WECHAT_ENV && !/micromessenger/i.test(navigator.userAgent)) {
  window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=123";
}

import {
  ConfigProvider,
  Button,
  Form,
  Field,
  CellGroup,
  Toast,
  List,
  Cell,
  Tab,
  Tabs,
  Popup,
  NavBar,
  Dialog,
  Tabbar, 
  TabbarItem,
  Empty,
  Calendar ,
  Grid,
   GridItem ,
   Image as VanImage,
   Icon,
   Tag,
   NoticeBar,
   ActionSheet,
  //  Loading,
  //  PullRefresh,
} from "vant";

const app = createApp(App);

app
  .use(router)
  .use(Button)
  .use(ConfigProvider)
  .use(Form)
  .use(Field)
  .use(CellGroup)
  .use(Toast)
  .use(List)
  .use(Cell)
  .use(Tab)
  .use(Tabs)
  .use(Popup)
  .use(axios)
  .use(NavBar)
  .use(Dialog)
  .use(Tabbar)
  .use(TabbarItem)
  .use(Empty)
  .use(Calendar)
  .use(Grid)
  .use(GridItem)
  .use(VanImage)
  .use(Icon)
  .use(Tag)
  .use(ActionSheet)
  .use(NoticeBar )
  // .use(Loading)
  // .use(PullRefresh)
  .use(preventReClick)
  .mount("#app");
